// module
import * as R from 'ramda'
// actions
import {
  dispatchSetConnectionStatus,
  dispatchSetLoaded,
} from '$comp/main/root.action'
// import { dispatchWappWorkerRegisterAll } from '../../logic/wappWorker/wappWorker.action'
// views
import { windowView } from '$comp/main/root.reducer'
// helpers
import {
  BROWSER,
  BROWSER_VERSION,
  isInPWA,
  IS_IOS,
  isPhoneOrTablet,
  OS_NAME,
  OS_VERSION,
  UA,
} from '$func/environmentInfo'
import { checkUpdateTWA } from '$logic/client-device'
import { getClientUserId } from '$logic/client-user'
import afterSignIn from '$hooks/after/signin'
import { isLoggedIn } from '$logic/auth'
import { initiateRouterListener } from '$logic/router/listener'
import { checkClockMismatch } from '$comp/modals/permission-dialog'
import { updateTwaPermissions } from '$logic/twaCommunication'
import { initializeRoomScrolls } from '$logic/room-last-scroll'
import { checkConnectionWithTWA } from '$logic/twaCommunication/twaCommunication.api'
import setMicPermission from '../../helper/functions/mediaPermission'

const sendPersistAnalytics = () => {
  const size = windowView()

  Promise.all(
    navigator.storage
      ? [
          typeof navigator.storage.estimate === 'function'
            ? navigator.storage.estimate()
            : undefined,
          typeof navigator.storage.persisted === 'function'
            ? navigator.storage.persisted()
            : undefined,
        ]
      : [],
  ).then(([estimate, persisted]) =>
    // eslint-disable-next-line no-undef
    analiteWithRetry('LOAD', {
      u: UA,
      b: BROWSER,
      bv: `${BROWSER} ${BROWSER_VERSION}`,
      m: isPhoneOrTablet,
      i: IS_IOS,
      d: new Date().toString(),
      s: {
        w: size.width,
        h: size.height,
      },
      p: {
        persisted,
        ...estimate,
      },
      pw: isInPWA,
      ov: `${OS_NAME} ${OS_VERSION}`,
      o: OS_NAME,
      n: R.pick(
        ['downlink', 'downlinkMax', 'type', 'effectiveType', 'rtt', 'saveData'],
        navigator.connection ||
          navigator.mozConnection ||
          navigator.webkitConnection ||
          {},
      ),
    }),
  )
}

export default () => {
  dispatchSetLoaded(true)
  // dispatchWappWorkerRegisterAll()
  sendPersistAnalytics()

  if (isLoggedIn()) {
    dispatchSetConnectionStatus('connecting')
    afterSignIn()
  } else dispatchSetConnectionStatus('signing in')

  // TODO[router]: Why setTimeout is needed?
  setTimeout(() => {
    setMicPermission()
    initiateRouterListener()

    updateTwaPermissions()
    checkConnectionWithTWA()
    checkClockMismatch()
    if (getClientUserId()) checkUpdateTWA()
  }, 0)

  initializeRoomScrolls()
}
